'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

require('./styles.sass');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ShadowBox = function ShadowBox(_ref) {
  var className = _ref.className,
      children = _ref.children,
      pad = _ref.pad,
      _ref$level = _ref.level,
      level = _ref$level === undefined ? 1 : _ref$level,
      props = (0, _objectWithoutProperties3.default)(_ref, ['className', 'children', 'pad', 'level']);
  return _react2.default.createElement(
    'div',
    (0, _extends3.default)({
      className: (0, _classnames2.default)('shadow-box', 'shadow-box--level-' + level, pad && 'shadow-box--pad', className)
    }, props),
    children
  );
};

ShadowBox.propTypes = {
  className: _propTypes2.default.string,
  children: _propTypes2.default.node,
  pad: _propTypes2.default.bool,
  level: _propTypes2.default.number
};

exports.default = ShadowBox;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@taxfyle/web-commons/lib/components/ShadowBox/index.js
// module id = 58
// module chunks = 0